<template>
  <div class="cross-chain-manage">
    <action-bar>
      <btn-style :btn-list="btnList"></btn-style>
      <div class="fill"></div>
      <instruction-btn :id="instruction.crosschain.id" :instruction-info="instruction.crosschain.instructionInfo"></instruction-btn>
    </action-bar>
    <common-bg-plate>
      <normal-table
        ref="commonTable"
        :table-col="tableCol"
        :table-data="list"
        :operator="operator"
        :operate-col="operateCol"
        :show-edit="true"
        :paging="paging"
        @pagination="handleSizeOrPageChange"
      >
        <template slot="status" slot-scope="{ param }">
          <span
            class="subscribe-status"
            :class="param.row.status ? 'is-subscribe' : 'is-unsubscribe'"
            >{{ subscribeStatus(param.row.status) || $constants.EMPTY }}</span
          >
        </template>
      </normal-table>
    </common-bg-plate>
    <create-cross-node ref="createNode" @update:list="getList()" @showDownload="startDownload"></create-cross-node>
    <subscribe-cross-node ref="subscribe" @update:list="getList()"></subscribe-cross-node>
    <download-dialog
      :dialog-visible.sync="showDownloadDialog"
      title="下载跨链服务部署包"
      :file-url="downloadUrl"
      :file-name="downloadFileName"
      :sure-text="downloadSureText"
      :cancel-text="downloadCancelText"
      :meta-data="downloadMetaData"
    ></download-dialog>
  </div>
</template>

<script>
import instruction from '@/instruction/index'
import { mapState, mapActions } from 'vuex'
import createCrossNode from './createCrossNode'
import subscribeCrossNode from './subscribeCrossNode'
import auth from '@/auth/index'

export default {
  name: 'CrossChain',
  components: {
    createCrossNode,
    subscribeCrossNode
  },
  data() {
    return {
      inputContent: '',
      fullscreenLoading: false, //下载loading
      btnList: [
        {
          btnContent: '新建跨链服务',
          click: () => {
            return this.createExpansionNode()
          },
          icon: 'icon-add',
          auth: auth.crosschain.create
        }
      ],
      // 设置table的列
      tableCol: [
        {
          prop: 'id',
          label: 'ID',
          minWidth: 149
        },
        {
          prop: 'chain1Id',
          label: '链1ID',
          minWidth: 135
        },
        {
          prop: 'chain2Id',
          label: '链2ID',
          minWidth: 130
        },
        {
          prop: 'serverIP',
          label: 'IP地址',
          minWidth: 142
        },
        {
          prop: 'serverPort',
          label: 'IP端口',
          minWidth: 137
        },
        {
          prop: 'status',
          label: '订阅状态',
          slotName: 'status',
          minWidth: 226
        },
        {
          prop: 'createAt',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row)
          },
          minWidth: 178
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '订阅',
          click: (row, col, cellValue) => {
            return this.handleSubscribe(row)
          },
          showText: false,
          formatter: (row, col, cellValue) => {
            return row.status == 0 || row.Subscribed === false
          },
          icon: 'icon-subscribe'
        },
        {
          text: '下载',
          click: (row, col, cellValue) => {
            return this.startDownload(row)
          },
          showText: false,
          icon: 'icon-download'
        },
        {
          text: '交易',
          click: (row, col, cellValue) => {
            return this.toRecord(row)
          },
          showText: false,
          icon: 'icon-transcation'
        }
      ],
      operateCol: {
        minWidth: 102
      },
      //下载对话框
      showDownloadDialog: false,
      downloadUrl: '',
      downloadFileName: '',
      downloadSureText: '确 定',
      downloadCancelText: '取 消',
      downloadMetaData: {},
      instruction
    }
  },
  computed: {
    ...mapState({
      list: state => state.crosschain.crosschain_list,
      paging: state => state.crosschain.crosschain_paging
    })
  },

  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getCrossChainLists']),
    getList(limit = 10, offset = 0) {
      let params = {
        offset,
        limit
      }
      this.getCrossChainLists(params)
    },
    subscribeStatus(status) {
      let statusArr = ['未订阅', '已订阅']
      return statusArr[status]
    },

    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },

    handleSubscribe(row) {
      this.$refs.subscribe.handleOpen(row)
    },
    handleToChannel(row) {
      console.log(row)
      this.$router.push({
        name: 'channel',
        query: {
          chainId: this.$route.query.chainId,
          detail: JSON.stringify(row)
        }
      })
    },
    refresh() {
      this.inputContent = ''
      this.getList()
    },
    startDownload(data, suggest = false) {
      this.downloadUrl = `/cbaas-service/v1/crosschain/download?crossChainId=${data.id}`
      this.downloadFileName = `跨链服务${data.id}部署包.zip`
      this.downloadMetaData = data
      this.downloadSureText = suggest ? '下载部署包':'确 定'
      this.downloadCancelText = suggest ? '稍后下载':'取 消'
      this.showDownloadDialog = true
    },
    createExpansionNode(row) {
      this.$refs.createNode.handleOpen(row)
    },
    handleRefresh() {
      this.getList()
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.createAt)
    },
    toRecord(row) {
      this.$router.push({
        name: 'crossChainRecord',
        query: {
          detail: JSON.stringify(row)
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme('cross-chain-manage', (
  --cross-chain-manage-list-operate-color: #45c2ff,
  --cross-chain-manage-list-status-subscribe-color: #55da62,
  --cross-chain-manage-list-status-unsubscribe-color: #e95757,
  --cross-chain-manage-list-status-unsubscribe-background-color: rgba(233, 87, 87, 0.34),
  --cross-chain-manage-list-record-status-wating: #45c2ff,
  --cross-chain-manage-list-record-status-running: #fac20a,
  --cross-chain-manage-list-record-status-success: #55da62,
  --cross-chain-manage-list-record-status-failed: #e95757,
), (
  --cross-chain-manage-list-operate-color: #45c2ff,
  --cross-chain-manage-list-status-subscribe-color: #55da62,
  --cross-chain-manage-list-status-unsubscribe-color: #e95757,
  --cross-chain-manage-list-status-unsubscribe-background-color: rgba(233, 87, 87, 0.34),
  --cross-chain-manage-list-record-status-wating: #45c2ff,
  --cross-chain-manage-list-record-status-running: #fac20a,
  --cross-chain-manage-list-record-status-success: #55da62,
  --cross-chain-manage-list-record-status-failed: #e95757,
));
.cross-chain-manage {
  --cross-chain-manage-list-min-height: var(--base-main-router-body-avaliable-height-with-action-bar);
  .normal-table-wrap {
    height: 100%;
    min-height: var(--cross-chain-manage-list-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--cross-chain-manage-list-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--cross-chain-manage-list-min-height);

        .subscribe-status {
          padding: var(--base-size-2) var(--base-size-8);
          display: inline-block;
          border-radius: var(--base-border-radius-small);

          &.is-subscribe {
            color: var(--cross-chain-manage-list-status-subscribe-color);
          }

          &.is-unsubscribe {
            color: var(--cross-chain-manage-list-status-unsubscribe-color);
            background-color: var(--cross-chain-manage-list-status-unsubscribe-background-color);
          }
        }

        .operate-item {
          color: var(--cross-chain-manage-list-operate-color);
        }
      }
    }
  }
}
</style>
